import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useId } from 'react';
import { Input } from '../../components/ui/input';
const ShadcnDateField = ({ formrValue, onUpdate, readonly = false }) => {
    // Ties the label to its control, so the field has an accessible name.
    const id = useId();
    const isDisabled = readonly || !formrValue.editable(formrValue.value);
    const [localValue, setLocalValue] = useState('');
    useEffect(() => {
        // Convert value to string for the input
        const val = formrValue.value;
        if (val && typeof val === 'object' && 'toISO' in val) {
            // Luxon DateTime
            setLocalValue(val.toFormat?.('yyyy-MM-dd') ?? val.toISO?.() ?? '');
        }
        else if (val instanceof Date) {
            setLocalValue(val.toISOString().split('T')[0]);
        }
        else {
            setLocalValue(String(val ?? ''));
        }
    }, [formrValue.value]);
    const validation = formrValue.validator(formrValue.value);
    const onChange = (event) => {
        const rawValue = event.target.value;
        setLocalValue(rawValue);
        onUpdate(formrValue.key, formrValue.setter(rawValue));
    };
    return (_jsxs("div", { className: "space-y-1", children: [_jsx("label", { htmlFor: id, className: "text-sm font-medium text-foreground", children: formrValue.label }), _jsx(Input, { id: id, type: "date", value: localValue, onChange: onChange, disabled: isDisabled, "aria-invalid": !validation.isValid }), !validation.isValid && (_jsx("p", { className: "text-sm text-destructive", children: validation.message }))] }));
};
export { ShadcnDateField };
//# sourceMappingURL=ShadcnDateField.js.map